import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const CustomerOnHoldWarningModal = ({ isOpen, toggle }) => {
  return (
    <Modal centered backdrop="static" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <span style={{ color: "black", fontWeight: "bold" }}>Important Notice</span>
      </ModalHeader>
      <ModalBody>
        <p style={{ color: "red", fontSize: "16px", fontWeight: "bold" }}>
          Please note this customer is currently on hold, any loans requested will be booked but won't be shipped until a purchase order number has been received.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>
          OK
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CustomerOnHoldWarningModal;